// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** The status of a seal row (the table's CHECK). */
export var EBallotBoxSealStatus;
(function (EBallotBoxSealStatus) {
    /** Closed; sealed when the grace period ends. */
    EBallotBoxSealStatus["PENDING"] = "pending";
    /** Sealed and locked; its entry is being posted to the bulletin board. */
    EBallotBoxSealStatus["SEALED"] = "sealed";
    /** Sealed, on the bulletin board, with its public record. */
    EBallotBoxSealStatus["PUBLISHED"] = "published";
    /** Not sealed: an incident. The ballot box stays locked. */
    EBallotBoxSealStatus["FAILED"] = "failed";
})(EBallotBoxSealStatus || (EBallotBoxSealStatus = {}));
/** How the election was closed (`closed_by.kind`). */
export var EBallotBoxClosedByKind;
(function (EBallotBoxClosedByKind) {
    EBallotBoxClosedByKind["USER"] = "user";
    EBallotBoxClosedByKind["SIGNED"] = "signed";
    EBallotBoxClosedByKind["SCHEDULED"] = "scheduled";
})(EBallotBoxClosedByKind || (EBallotBoxClosedByKind = {}));
/** Why the sealer left a pending box pending on its last attempt (`waiting_reason`). */
export var EBallotBoxWaitingReason;
(function (EBallotBoxWaitingReason) {
    /** Its deadline hadn't passed. */
    EBallotBoxWaitingReason["DEADLINE"] = "deadline";
    /** A channel of the election is enabled and not closed (`channel_open:KIOSK`). */
    EBallotBoxWaitingReason["CHANNEL_OPEN"] = "channel_open";
    /**
     * A channel the election doesn't enable is open or paused, or ran, and
     * isn't closed (`channel_not_enabled:KIOSK`).
     */
    EBallotBoxWaitingReason["CHANNEL_NOT_ENABLED"] = "channel_not_enabled";
    /** The box has ballots of a channel that isn't closed (`channel_has_ballots:KIOSK`). */
    EBallotBoxWaitingReason["CHANNEL_HAS_BALLOTS"] = "channel_has_ballots";
    /** Datafix votes are in progress (`datafix_votes:3`). */
    EBallotBoxWaitingReason["DATAFIX_VOTES"] = "datafix_votes";
    /** Ballots of the box aren't on the electoral log yet (`sequencer:3`): the sequencer adds them. */
    EBallotBoxWaitingReason["SEQUENCER"] = "sequencer";
    /** Another run was sealing it. */
    EBallotBoxWaitingReason["BUSY"] = "busy";
    /** The attempt failed and is retried (`error:<short>`). */
    EBallotBoxWaitingReason["ERROR"] = "error";
})(EBallotBoxWaitingReason || (EBallotBoxWaitingReason = {}));
/** The waiting reason of a pending box, or null when there is none or it is unknown. */
export var parseWaitingReason = function (value) {
    if (!value)
        return null;
    var separator = value.indexOf(":");
    var code = separator < 0 ? value : value.slice(0, separator);
    var detail = separator < 0 ? undefined : value.slice(separator + 1);
    var reason = Object.values(EBallotBoxWaitingReason).find(function (known) { return known === code; });
    return reason ? { reason: reason, detail: detail } : null;
};
